<template>

  <div class="home uk-child-width-1-1" uk-grid>
    <carousel/>
<!--    <latest-news/>-->
    <!--<sportsDayResults/>-->
    <call-to-action/>
    <feature-story-snip/>
    <wholistic-life/>
<!--    <cookie-modal />-->
<!--    <AdRow />-->
    <!--<ncu-impact/>-->

    <admissions/>
    <statements/>
    <colleges/>

    <where-are-our-grads/>
    <!--<covid/>-->
    <upcoming-events/>
    <!--<our-stories/>-->
    <by-categories/>

    <plea/>

  </div>


</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Carousel from "../components/home/carousel";
import LatestNews from "../components/home/latestNews";
import Colleges from "../components/home/colleges";
import ByCategories from "../components/home/byCategories";
import UpcomingEvents from "../components/home/upcomingEvents";
import OurStories from "../components/home/ourStories";
import WhereAreOurGrads from "../components/home/whereAreOurGrads";
import NcuImpact from "../components/home/ncuImpact";
import CallToAction from "../components/home/callToAction";
import Plea from "../components/home/plea";
import Admissions from "../components/home/admissions";
import WholisticLife from "../components/home/wholisticLife";
import FeatureStorySnip from "../components/home/featureStorySnip";
import Covid from "../components/home/covid";
import AdRow from "../components/home/adRow";
import Statements from "@/components/home/statements";
import sportsDayResults from "@/components/home/sportsDayResults";
import CookieModal from "@/components/Notices/cookieModal.vue";


export default {
  name: 'Home',
  components: {
    CookieModal,
    sportsDayResults,
    Statements,
    AdRow,
    Covid,
    FeatureStorySnip,
    WholisticLife,
    Admissions,
    Plea,
    CallToAction,
    NcuImpact,
    WhereAreOurGrads,
    OurStories,
    UpcomingEvents,
    ByCategories,
    Colleges,
    LatestNews,
    Carousel,
    HelloWorld
  },
  metaInfo: {
    // Children can override the title.
    title: 'Northern Caribbean University ',
    // Result: My Page Title ← My Site
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    //titleTemplate: '%s ← My Site',
    // Define meta tags here.
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Unlock your potential at Northern Caribbean University, a leading institution dedicated to empowering students through quality education and holistic development.'},
      { links: [
          { rel: "canonical", href: "https://www.ncu.edu.jm"}
      ]}
    ]
  }
}
</script>

<style scoped>

</style>
